import React, { useState } from 'react';
import { ComponentWrapper } from '../../../helperComponents/ComponentWrapper';
import { StyleSheet, Text, useWindowDimensions, View } from 'react-native';
import { BackButtonV2 } from '../../../helperComponents/BackButtonV2';
import { DropdownMenu } from '../../../helperComponents/DropdownMenu/DropdownMenu';
import TextIconBox from '../../../helperComponents/TextIconBox';
import { BeePlayAFriendHexagon } from '../../../../resources/svgComponents/BeePlayAFriendHexagon';
import { applyTransparency } from '../../../../constants/colors';
import { BeePracticeBotsHexagon } from '../../../../resources/svgComponents/BeePracticeBotsHexagon';
import StatsTableBuzz from '../../../helperComponents/StatsTableAssessmentPractice';
import { BeeBuzzGameHexagon } from '../../../../resources/svgComponents/BeeBuzzGameHexagon';
import GameButton from '../../../helperComponents/Button/GameButton';
import { useAIPracticeGamesQuery } from './useAIPracticeGamesQuery.gql';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';
import { useSignedInContext } from '../../../../context/SignedInContext';
import StatsTableAIPractice from '../../../helperComponents/StatsTableAIPractice';
import { useGetHivesQuery } from '../../MyHives/useGetHivesQuery.gql';
import StatsTablePlayFriend from '../../../helperComponents/StatsTablePlayFriend';
import StatsTableAssessmentPractice from '../../../helperComponents/StatsTableAssessmentPractice';

export default function GymStats({ navigation, route }) {
  const { width } = useWindowDimensions();

  const { queryUserId = null, userName = null } = route?.params ?? {};

  const [view, setView] = useState<'friend' | 'practice' | 'buzz'>('friend');

  const screenLimit = width < 1200;

  const { error: getHivesError, data: getHivesData, refetch: refetchHive } = useGetHivesQuery();

  return (
    <ComponentWrapper hasInset hasScroll={true} hideBee={false}>
      <DropdownMenu
        backButton={
          <BackButtonV2
            onPress={() => {
              if (navigation.canGoBack()) {
                navigation.goBack();
              } else {
                if (queryUserId) {
                  navigation.navigate('Lobby');
                } else {
                  navigation.navigate('Lobby', {
                    gym: true,
                  });
                }
              }
            }}
          />
        }
        top={20}
      />
      <View
        style={[
          styles.contentContainer,
          screenLimit && { flexDirection: 'column', justifyContent: 'flex-start', marginTop: 20 },
        ]}
      >
        <View style={[styles.mainContainer]}>
          <View style={[styles.titleContainer, screenLimit && { alignItems: 'flex-start' }]}>
            <Text style={[styles.title]}>{userName} HIVE GYM</Text>
          </View>
          {screenLimit && (
            <View style={[styles.toggleButtonsContainer]}>
              <GameButton
                label="Play a Friend"
                active={view === 'friend'}
                onPress={() => setView('friend')}
              />
              <GameButton
                label="Practice"
                active={view === 'practice'}
                onPress={() => setView('practice')}
              />
              <GameButton
                label="Buzz Game"
                active={view === 'buzz'}
                onPress={() => setView('buzz')}
              />
            </View>
          )}
          <View style={[styles.versusStatsContainer]}>
            {(!screenLimit || view === 'friend') && (
              <View style={[styles.versusStatItem, , !screenLimit && { marginRight: 20 }]}>
                {!screenLimit && (
                  <TextIconBox label="Play a Friend" icon={<BeePlayAFriendHexagon />} />
                )}

                <View style={{ marginTop: 9 }}>
                  <StatsTablePlayFriend queryUserId={queryUserId} />
                </View>
              </View>
            )}
            {(!screenLimit || view === 'practice') && (
              <View style={[styles.versusStatItem]}>
                {!screenLimit && (
                  <TextIconBox label="Practice vs bots" icon={<BeePracticeBotsHexagon />} />
                )}

                <View style={{ marginTop: 9 }}>
                  <StatsTableAIPractice queryUserId={queryUserId} />
                </View>
              </View>
            )}
          </View>
        </View>
        {(!screenLimit || view === 'buzz') && (
          <View
            style={[
              styles.sideContainer,
              screenLimit && {
                width: 364,
                backgroundColor: 'transparent',
                marginLeft: 0,
                marginTop: 0,
                paddingHorizontal: 0,
              },
            ]}
          >
            {!screenLimit && (
              <View style={[styles.buzzTitleContainer]}>
                <Text style={[styles.buzzGameTitle]}>Buzz Game Practice</Text>
                <BeeBuzzGameHexagon />
              </View>
            )}
            <View style={[styles.buzzTableContainer, screenLimit && { marginTop: 9 }]}>
              <StatsTableAssessmentPractice queryUserId={queryUserId} />
            </View>
          </View>
        )}
      </View>
    </ComponentWrapper>
  );
}
const styles = StyleSheet.create({
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    height: 780,
  },
  mainContainer: {
    marginTop: 100,
  },
  titleContainer: {
    width: '100%',
    alignItems: 'flex-end',
    marginBottom: 20,
  },
  title: {
    fontFamily: 'Secular One',
    fontSize: 35,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#E87030',
    fontWeight: '400',
  },
  toggleButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  versusStatsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  versusStatItem: {
    width: 364,
  },
  sideContainer: {
    backgroundColor: '#FEDD88',
    width: 417,
    paddingHorizontal: 10,
    marginLeft: 40,
    marginTop: 60,
    borderRadius: 16,
  },
  buzzTitleContainer: {
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buzzGameTitle: {
    fontFamily: 'Secular One',
    fontSize: 20,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#E87030',
    fontWeight: '400',
  },
  buzzTableContainer: {
    marginTop: 16,
  },
});
